import { computed } from 'mobx';

export default class DaqProcessorModel {
  id;
  store;

  constructor(store, daqProcessor) {
    this.store = store;
    this.id = +daqProcessor.id;
    this.protocol = daqProcessor.protocol;
    this.data_source_id = daqProcessor.data_source_id;
    this.parser = daqProcessor.parser;
    this.aes_key = daqProcessor.aes_key;
    this.location_id = daqProcessor.location_id;
    this.address = daqProcessor.address;
    this.port_no = daqProcessor.port_no;
    this.location = (daqProcessor.location && this.store.daqLocationStore.resolveItem(Array.isArray(daqProcessor.location) ? daqProcessor.location[0] : daqProcessor.location)) || {};
  }

  @computed get asJson() {
    return {
      id: +this.id,
      protocol: this.protocol,
      data_source_id: this.data_source_id,
      parser: this.parser,
      aes_key: this.aes_key,
      location_id: this.location_id,
      address: this.address,
      port_no: this.port_no,
      location: this.location.asJson || {
        source_location: '',
        destination_location: '',
        user_name: '',
        user_password: '',
        interval: '',
        mqtt_topic: '',
        certificate: '',
      },
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.protocol = json.protocol;
    this.data_source_id = json.data_source_id;
    this.parser = json.parser;
    this.aes_key = json.aes_key;
    this.location_id = json.location_id;
    this.address = json.address;
    this.port_no = json.port_no;
    this.location = (json.location && this.store.daqLocationStore.resolveItem(json.location)) || {};
  }
}



// WEBPACK FOOTER //
// ./src/models/DaqProcessorModel.js